import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '@/hooks/useApiMutation';
import { apiPost, operationsClient } from '@/lib/api/client';
import { reviewPlatformsV2Endpoints } from '@/lib/api/endpoints';
import { reviewPlatformKeys } from '@/lib/queryKeys';
import type { ConnectUrlPlatformDto, PlatformConfigRecord } from '@/types/review-platform';

/**
 * Connect a URL-paste platform (Yelp / BBB / Thumbtack).
 * POST /v2/review-platforms/settings/connect-url
 *
 * OAuth platforms (Google / Facebook) start at `/oauth/:platform/url` — see
 * `useOAuthAuthorizationUrl`.
 */
export function useConnectUrlPlatform(locationId: string | null = null) {
  const queryClient = useQueryClient();
  return useApiMutation<PlatformConfigRecord, ConnectUrlPlatformDto>({
    mutationFn: (dto) =>
      apiPost<PlatformConfigRecord, ConnectUrlPlatformDto>(
        operationsClient,
        reviewPlatformsV2Endpoints.connectUrl(),
        dto,
      ),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: reviewPlatformKeys.settings(locationId),
      });
      toast.success('Platform connected');
    },
  });
}
